import Vue from 'vue';
import Vuex from 'vuex';
import menu from '@/menu';
import config from '@/config';
import authMod from "@/store/modules/auth";
import cartMod from "@/store/modules/cart";
import notifyMod from "@/store/modules/notify";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    authMod: authMod,
    cartMod: cartMod,
    notifyMod: notifyMod
  },
  state: {
    pageTitle: 'Home',
    loader: false,
    showHeaderSlider: false,
    contactCounter: 0,
    qasNotRespCounter: 0,
    config: config,
    menu: menu,
    options: 123,
    system: null,
    drawer: null,
  },
  mutations: {
    setLoader (state, payload) {
      state.loader=payload;
    },
    setContactCounter (state, payload) {
      state.contactCounter=payload;
    },
    setQasNotRespCounter (state, payload) {
      state.qasNotRespCounter=payload;
    },
    setOptions (state, payload) {
      state.options=payload;
    },
    setSystem (state, payload) {
      state.system=payload;
    },
    setHeaderSlider (state, payload) {
      state.showHeaderSlider=payload;
    },
    setDrawer (state, payload) {
      state.drawer=payload;
    },
  },
  actions: {
    countContact ({ commit }) {
      return axios
        .get('api/v1/contacts-counter')
        .then(({ data }) => {
          commit('setContactCounter', data);
        })
    },
    countQasNotResp ({ commit }, expertId) {
      // /0 mean not reply
      return axios
        .get(`api/v1/supports-counter-bystatus/${expertId}/0`)
        .then(({ data }) => {
          commit('setQasNotRespCounter', data);
        })
    },
    getOptions ({ commit }) {
      return axios
        .get('api/v1/public/options')
        .then(({ data }) => {
          commit('setOptions', data);
        })
    },
    getSystem ({ commit }) {
      return axios
        .get('api/v1/public/systems/1')
        .then(({ data }) => {
          commit('setSystem', data);
        })
    },
    getLoader({commit}, status) {
      commit('setLoader', status);
    },
    toggleHeaderSlider({commit}, status) {
      commit('setHeaderSlider', status);
    },
    toggleDrawer({commit}, status) {
      commit('setDrawer', status);
    }
  },
  getters : {
    
  }
})

export default store;
